<template>
  <div style="display: flex">
    <div style="flex: 1; overflow: hidden">
      <div class="content_header">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/main?lang=' + lang }">{{
            cooperation.title
          }}</el-breadcrumb-item>
          <el-breadcrumb-item v-for="(item, index) in brandList" :key="index">{{
            item.categoryName
          }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div
        style="border: 1px solid #e5e5e5; margin-top: 20px; margin-left: 20px; margin-right: 10px;"
      >
        <div class="div1" style="margin-top: 10px;">
          <span style="line-height: 30px; margin-top: 10px">{{ $t("library.quickLink") }} : </span>
        </div>
        <div class="div2 content_tag">
          <div class="tag-group div2-tag">
            <el-row class="div2-row-tag">
              <el-tooltip
                v-for="item in sortTagPlug(tagsList.filter(v => v.tagType === 2))"
                :key="item.id"
                :content="item.tagName"
                placement="right"
                :open-delay="openDelay"
              >
                <button
                  class="el-row-span no-active"
                  :class="{ active: quickLinkId == item.id, default: true }"
                  @click="selectedQuickTag(item)"
                >
                  {{ item.tagName }}
                </button>
              </el-tooltip>
            </el-row>
          </div>
        </div>
        <div class="div3" style="margin-top: 10px;margin-bottom: 10px;">
          <span style="line-height: 30px; margin-top: 20px">{{ $t("library.category") }} :</span>
        </div>
        <div class="div4 content_category" style="padding-bottom: 10px;">
          <div class="tag-group" style="margin-top: 10px;">
            <el-row class="el-row-tag">
              <el-tooltip
                v-for="item in sortTagPlug(tagsList.filter(v => v.tagType !== 2 && !v.parentId))"
                :key="item.id"
                :content="item.tagName"
                placement="right"
                :open-delay="openDelay"
              >
                <button
                  class="el-row-span no-active"
                  :key="item.id"
                  :class="{ active: tagId == item.id, default: true }"
                  @click="selectedTag(item.tagName, item.id, item.isAll)"
                >
                  {{ item.tagName }}
                </button>
              </el-tooltip>
            </el-row>
          </div>
        </div>
        <div class="div3" style="margin-top: 10px;margin-bottom: 10px;">
          <span style="line-height: 30px; margin-top: 20px"
            >{{ $t("library.subCategory") }} :
          </span>
        </div>
        <div class="div4 content_category" style="min-height: 48px;">
          <div class="tag-group">
            <el-row class="el-row-tag">
              <el-tooltip
                v-for="item in subTagItems"
                :key="item.id"
                :content="item.tagName"
                placement="right"
                :open-delay="openDelay"
              >
                <button
                  class="el-row-span no-active"
                  @click="selectedSubTag(item)"
                  :key="item.id"
                  :class="{ active: fileType === item.id, default: true }"
                >
                  {{ item.tagName }}
                </button>
              </el-tooltip>
            </el-row>
          </div>
        </div>
      </div>
      <!--节点过滤  -->
      <div class="library_content_table">
        <el-tree
          class="filter-tree table-set"
          icon-class="el-icon-document-copy"
          :data="data"
          :empty-text="$t('document.emptyResult')"
          :props="defaultProps"
          :filter-node-method="filterNode"          
          :default-expand-all="defaultExpandAll"
          ref="tree"
          show-checkbox
          node-key="id"
          @check-change="handleCheckChange"
        >
          <dl
            slot-scope="{ node, data }"
            style="width: 100%; height: 40px; display: flex; line-height: 40px"
          >
            <dt style="flex: 1; overflow: hidden">
              <!-- <span class="fixed-label align-middle" @click="handleView(data)"> -->
              <span class="fixed-label align-middle">
                <!-- 文字过长显示气泡 -->
                <el-tooltip v-if="data.fileName.length > 20" placement="right">
                  <div slot="content">{{ data.fileName }}</div>
                  <!-- <a :href="data.filesUrl" download :title="$t('library.downloadTip')">{{ data.fileName }}</a> -->
                  <span
                    @click="preview(data)"
                    >{{ data.fileName }}</span
                  >
                </el-tooltip>
                <!-- <a v-else  :href="data.filesUrl" download :title="$t('library.downloadTip')">{{ data.fileName }}</a> -->
                <span
                  v-else
                  @click="preview(data)"
                  >{{ data.fileName }}</span
                >              
              </span>
            </dt>
            <dd
              style="position: relative; width: 250px; text-align: right; box-sizing: border-box;"
            >
              <span class="fixed-width align-middle">{{
                validPerson(data.personName)
              }}</span
              >&nbsp;
              <span class="fixed-width align-middle">{{ data.updateTime.split(" ")[0] }}</span>
              <span class="fixed-width align-middle">
                <i class="el-icon-download" :style="{ visibility: isAvailableDownload(data) ? 'visible' : 'hidden' }" style="margin-left: 4px" @click="download(data)"></i>
              </span>
            </dd>
          </dl>
        </el-tree>
        <el-row
          v-if="total > 10"
          class="list-pagination"
          style="margin-bottom:10px;padding-top: 25px;"
        >
          <el-pagination
            style="margin-right: 2px;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </el-row>
      </div>
    </div>
    <div class="fact-pannel">
      <p style="font-weight: 700;">Fact Data</p>
      <el-card
        class="fact-card"
        shadow="hover"
        style="margin: 6px 0;"
        :head-style="{ padding: '10px' }"
        :body-style="{ padding: '10px' }"
        v-for="item in factDataList"
        :key="item.id"
      >
        <div slot="header">
          <span style="font-weight: 700;">{{ item.name }}</span>
        </div>
        <p style="color: #00b5b1">{{ item.text }}</p>
        <p style="color: #666">{{ item.remark }}</p>
      </el-card>
      <!-- <p style="font-weight: 700;">{{ item.name }}</p>
        <p style="color: #00b5b1">{{ item.text }}</p>
        <p style="color: #666">{{ item.remark }}</p> -->
    </div>
    <el-dialog :title="$t('library.filename')" :visible.sync="dialogVisible">
      <el-form ref="downloadForm" width="480px" :model="downloadForm">
        <el-form-item
          prop="name"
          :label="$t('library.filename')"
          label-width="120px"
          :rules="[{ required: true }]"
        >
          <el-input v-model="downloadForm.name" autocomplete="off">
            <template slot="append">.zip</template>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t("cancel") }}</el-button>
        <el-button
          type="primary"
          :disabled="!this.checkdItems.length"
          @click="batchDownload"
          style="background: #00b5b1;"
          >{{ $t("save") }}</el-button
        >
      </div>
    </el-dialog>
    <el-badge
      :value="checkdItems.length"
      type="danger"
      style="position: fixed; z-index: 999; bottom: 54px; right: 37px;"
    >
      <el-button
        round
        type="primary"
        size="small"
        icon="el-icon-download"
        style="padding: 6px; background: #00b5b1; font-size: 36px; border-radius: 100%;"
        @click="batchDownloadHandler"
      ></el-button>
      <img
        v-show="batchdownloadQueueConuter"
        src="./loading.gif"
        alt=""
        style="position: absolute; top: 70%; left: 0"
      />
    </el-badge>

    <el-dialog
      :visible.sync="previewDialogVisible"
      append-to-body
      custom-class="preview-dialog"
      fullscreen
    >
      <!-- <p slot="title" :style="{  width: 'calc(100% - 30px)',
      display: 'inline-block',
      'white-space': 'nowrap',
      color: '#fff',
      overflow: 'hidden',
      'text-overflow': 'ellipsis'}"> {{ previewTitle }}</p> -->
      <div
        v-loading="previewLoading"
        element-loading-spinner="el-icon-loading"
        style="width: 100%; height: 100%; overflow: auto"
      >
        <div
          v-if="canIframeOpenFile(previewUrl) === 0"
          style="text-align: center; background-color: #666;height: 100%;"
        >
          <img :src="previewUrl" @load="onPreviewLoad" />
        </div>
        <iframe
          v-else
          id="preiveIframe"
          :src="previewUrl"
          width="100%"
          height="100%"
          style="border: none;background-color: #666; display: flex; justify-content: center;align-items: center;"
          @load="onPreviewLoad"
        ></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import streamSaver from 'streamsaver';
import { messageWarn } from "@/utils/util";
import "element-ui/lib/theme-chalk/index.css";
import { switchLanguage } from "@/api/sigen/paginationLang";
import {
  listBase,
  listParentTechnicalApi,
  listPlusTechnicalApi,
  listTagPlus,
  getFactData,
  batchDownloadLocalZip
} from "@/api/sigen/library";
export default {
  inject: ["getCateId"],
  data() {
    return {
      previewDialogVisible: false,
      previewLoading: false,
      previewTitle: "",
      previewUrl: "",
      batchdownloadQueueConuter: 0,
      downloadForm: {
        name: ""
      },
      dialogVisible: false,
      openDelay: 1000,
      language: this.$i18n.locale,
      Info: "Info",
      info: "info",
      login: false,
      isLogin: 0,
      lang: "en",
      filterText: "",
      tagsList: [],
      documentList: [],
      brandList: [],
      cooperation: "",
      loginView: 0,
      fileType: null,
      fileName: "",
      filePath: "",
      tagId: null,
      categoryId: null,
      quickLinkId: null,
      listLoading: true,
      isLastPage: false,
      defaultExpandAll: true,
      total: 0,
      pageNum: 1,
      pageSize: 10,
      data: [],
      defaultProps: {
        children: "children",
        label: "label"
      },
      items: [
        { type: "info", label: "文档文件" },
        { type: "info", label: "视频文件" },
        { type: "info", label: "录音文件" },
        { type: "info", label: "其他" }
      ],
      listTag: [
        { type: "info", label: "标签一" },
        { type: "info", label: "标签二" },
        { type: "info", label: "标签三" },
        { type: "info", label: "标签四" },
        { type: "info", label: "标签五" }
      ],
      actives: "全部",
      active: "全部",
      factDataList: [],
      checkdItems: []
    };
  },
  filterText(val) {
    this.$refs.tree.filter(val);
  },
  mounted() {
    console.log(">>>>>>>>>>>>>>>>>>>>>>>>  mounted  getCateId :  ", this.getCateId());
  },
  async created() {
    let lang = this.getRouteParams();
    this.handleSetLanguage(lang);
    this.checkLogin();
    this.lang = lang;
    this.switchLanguage(this.lang);
    this.listStepPull(this.isLogin, lang, this.getCateId());
    await this.listTagList(this.isLogin, lang);
    this.listTechnicalPull();
    getFactData().then(res => {
      const list = res.data.result.list || [];
      this.$set(this, "factDataList", list);
    });
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    }),
    subTagItems() {
      if (!this.tagId) {
        return [];
      }

      return this.sortTagPlug(this.tagsList.filter(v => v.parentId == this.tagId));
    },
    batchDownloadItems() {
      return this.checkdItems.filter(v => v.isCatalogue);
    },
    previewLocation() {
      const { width, height } = window.screen;
      const left = 0;
      const top = 0;

      return {
        width,
        height,
        left,
        top
      };
    }
  },
  methods: {
    // 批量下载
    batchDownloadHandler() {
      const maxLimit = 50;

      if (this.batchDownloadItems.length > maxLimit) {
        this.$message(this.$t("library.maxLimit", { value: maxLimit }));
        return;
      }

      this.dialogVisible = true;
      const custom = "sigen-library-" + new Date().getTime();
      this.downloadForm.name = custom;
    },
    batchDownload() {
      this.$refs.downloadForm.validate(valid => {
        if (!valid) return;
        const name = this.downloadForm.name;
        this.dialogVisible = false;
        this.downloadForm.name = "";

        // 批量下载
        const listIds = this.batchDownloadItems.map(row => row.id).join(",");
        // const listIds = [1205, 1195].join(',')
        const filename = name + ".zip";
        batchDownloadLocalZip(filename, listIds, step => {
          this.batchdownloadQueueConuter += step;
        });
        this.$set(this, "checkdItems", []);
        this.$refs.tree.setCheckedKeys([]);
        this.$message("Tip: Start downloading");
      });
    },
    handleCheckChange() {
      const nodes = this.$refs.tree.getCheckedNodes();
      this.$set(this, "checkdItems", nodes);
    },
    isAvailableDownload (data) {
      const { redirection, redirectionUrl, filesUrl } = data;
      const url = redirection ? redirectionUrl : filesUrl;
      return !!url
    },
    download(data) {
      const { redirection, redirectionUrl, filesUrl } = data;
      const url = redirection ? redirectionUrl : filesUrl;
      if (url) {
        this.downloadAnyFile(url);
      }
    },
    preview(data) {
      const { redirection, redirectionUrl, filesUrl } = data;
      let url = redirection ? redirectionUrl : filesUrl;

      if (url && this.canIframeOpenFile(url) > -1) {
        // url = Math.random() > 0.5
        // ? 'https://library.sigenergy.com/other/10/产品规格书 - Sigen PV 100_110_125M1-HYA-CN - 20250103.pdf'
        // : 'https://library.sigenergy.com/other/150/思格一期脑图.png'
        // window.open(url, 'sigen_preview', `width=${width},height=${height},left=${left},top=${top},location=0`)

        this.previewDialogVisible = true;
        this.previewLoading = true;
        this.previewTitle = data.fileName;
        this.previewUrl = url;
      }
    },
    onPreviewLoad() {
      this.previewLoading = false;
    },
    canIframeOpenFile(url) {
      // 提取文件后缀名
      const extension = url
        .split(".")
        .pop()
        .toLowerCase();

      // 支持在 iframe 中打开的格式
      const supportedFormats = [
        ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"], // 图片
        [
          "pdf",
          "html",
          "htm",
          "txt",
          "xml",
          "json" // 文档
        ],
        ["mp4", "webm", "ogv"], // 视频
        ["mp3", "wav", "ogg"] // 音频
      ];

      for (let i = 0; i < supportedFormats.length; i++) {
        const formats = supportedFormats[i];
        if (formats.includes(extension)) {
          return i;
        }
      }

      return -1;
    },
    async downloadAnyFile(url) {
      // url = 'https://support-video-ap.sigenergy.com/yunmianshi/exam/video/84/sigenee410fab-bce3-4426-b223-e31406c0cef9.mp4'; // 替换为你的文件URL
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error('Network response was not ok ' + response.statusText);
        }

        const contentDisposition = response.headers.get('content-disposition');
        const file = url.slice(url.lastIndexOf('/') + 1, 1000);
        const filename = contentDisposition ? contentDisposition.match(/filename="(.+)"/)[1] : file;

        const fileStream = streamSaver.createWriteStream(filename);

        const reader = response.body.getReader();
        const writer = fileStream.getWriter();

        while (true) {
          const { done, value } = await reader.read();
          if (done) {
            writer.close();
            console.log('Download complete');
            break;
          }
          await writer.write(value);
        }
      } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
      }
    },
    switchLanguage(lang) {
      switchLanguage(lang);
    },
    /** 点击快速链接 */
    selectedQuickTag(item) {
      this.quickLinkId = item.id;
      this.fileType = null;
      this.tagId = null;
      this.pageNum = 1;
      this.listTechnicalPull();
    },
    /** 点击一级 */
    selectedTag(name, tagId, all) {
      this.quickLinkId = null;
      this.active = name;
      this.tagId = tagId;
      this.fileType = null;
      this.pageNum = 1;
      this.listTechnicalPull();
    },
    /** 点击二级 */
    selectedSubTag(item) {
      this.quickLinkId = null;
      this.fileType = item.id;
      this.pageNum = 1;
      this.listTechnicalPull();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      if (this.listLoading) {
        messageWarn(this, this.$t("load.loading"));
        return;
      }
      this.listTechnicalPull();
    },
    sortTagPlug(tags) {
      return tags.sort((a, b) => a.sort - b.sort);
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      if (this.listLoading) {
        messageWarn(this, this.$t("load.loading"));
        return;
      }
      this.listTechnicalPull();
    },
    listTagList(isLogin, lang) {
      return listTagPlus(isLogin, lang, 1, 10000)
        .then(res => {
          this.tagsList = res.data.result.list;
          if (this.tagsList === null && this.tagsList === undefined) {
            return;
          }
          // 找到第一个 parent 为 null 的标签
          const sorted = this.sortTagPlug(
            this.tagsList.filter(v => v.tagType !== 2 && !v.parentId)
          );
          const first = sorted.find(t => !t.parentId);
          if (first) {
            this.active = first.tagName;
            this.tagId = first.id;
          }
        })
        .catch(() => {
          this.tagsList = [];
        });
    },
    listStepPull(isLogin, lang, cateId) {
      if (lang === undefined) {
        return;
      }
      listBase(isLogin, lang, cateId)
        .then(res => {
          console.info("*********");
          console.info(res);
          this.cooperation = res.data.result.cooperation;
          this.brandList = res.data.result.brandList;
          this.documentList = res.data.result.documentList;
          if (this.documentList !== null && this.documentList !== undefined) {
            this.actives = this.documentList[0].tagName;
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    listTechnicalPull() {
      const params = {
        loginView: this.loginView,
        langCode: this.lang,
        categoryId: this.getCateId(),
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        permission: this.userInfo.permission || 0
      };
      let request;
      if (this.quickLinkId) {
        Object.assign(params, {
          quicklinkId: this.quickLinkId,
          catesecId: -1,
          parentid: -1
        });
        // GET url: literatureUrl + "/listTechnical",
        request = listPlusTechnicalApi;
      } else {
        // 二级
        if (this.tagId && this.fileType) {
          Object.assign(params, { catesecId: this.fileType, quicklinkId: -1 });
          request = listPlusTechnicalApi;
          // 一级
        } else {
          Object.assign(params, { parentid: parseInt(this.tagId), quicklinkId: -1 });
          // GET  literatureUrl + "/listParentTechnical",
          request = listParentTechnicalApi;
        }
      }

      this.checkdItems = [];

      request(params)
        .then(res => {
          this.data = res.data.result.data;
          this.total = res.data.result.total;
          this.isLastPage = res.data.result.isLastPage;
          this.listLoading = false;
        })
        .catch(_error => {
          messageWarn(this, this.$t("load.noMoreData"));
          this.listLoading = false;
        });
    },
    handleNodeClick(data, node, component) {
      // 在这里处理节点点击事件
      console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>   result  : ", data, node, component);
    },
    handleDownload(data) {
      // file downlouad
      console.log(
        ">>>>>>>>>>>>>>>>>>>>>>>>>> handleDownload data result fileName : ",
        data.fileName
      );
      console.log(">>>>>>>>>>>>>>>>>>>>>>>>>> handleDownload data result data id : ", data.id);
      var name = "";
      var charToCheck = ".";
      if (data.fileName === undefined || data.fileName === null) {
        name = "documents.zip";
      } else {
        var filename = data.fileName;
        if (data.fileName.includes(charToCheck)) {
          filename = data.fileName.substring(0, data.fileName.lastIndexOf(charToCheck));
        }

        name = filename + ".zip";
      }

      // downloadLocalZip(data.id, name);
      this.$message("Tip: Start downloading");
    },
    handleDownloadPDF(data) {
      // file downlouad
      console.log(">>>>>>>>>>>>>>>>>>>>>>>>>> handleDownloadPDF fileName : ", data.fileName);
      console.log(">>>>>>>>>>>>>>>>>>>>>>>>>> handleDownloadPDF data id : ", data.id);
      var name = "";
      var charToCheck = ".";
      if (data.fileName === undefined || data.fileName === null) {
        name = "documents.pdf";
      } else {
        var filename = data.fileName;
        if (data.fileName.includes(charToCheck)) {
          filename = data.fileName.substring(0, data.fileName.lastIndexOf(charToCheck));
        }

        console.log(">>>>>>>>>>>>>>>>>>>>>>>>>> handleDownloadPDF filename : ", filename);
        name = filename + ".pdf";
      }

      // downloadLocalPdf(data.id, name);
      this.$message("Tip: Start downloading");
    },
    handleView(data) {
      if (data.isCatalogue === 0) {
        return;
      }
      // file view
      window.open(data.filesUrl, "_blank");
    },
    validPerson(data) {
      if (data !== null && data !== undefined) {
        return data.replace(/\d/g, "").replace("@sigenergy.com", "");
      }
      return "";
    },
    getRouteParams() {
      // 使用 let phone=this.$route.query.name 来获Get请求参数的值
      let lang = this.$route.query.lang;
      return lang;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleSetLanguage(lang) {
      this.$i18n.locale = lang;
      this.language = lang;
    },
    checkLogin() {
      if (this.userInfo.id !== undefined) {
        this.login = true;
      }
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleTest(data) {
      console.log(">>>>>>>>>>>>>>>>>>>>>>>>>> handleTest data.fileName : ", data.fileName);
    }
  }
};
</script>

<style lang="scss">
.fact-pannel .el-card__header {
  padding: 5px;
}

.library_content_table .el-tree-node__content {
  height: 20px;
}

/* 调整树形控件节点的上下行距 */
.library_content_table .el-tree-node__content {
  margin-top: 5px;
  /* 设置节点之间的上边距 */
  margin-bottom: 5px;
  /* 设置节点之间的下边距 */
  padding-top: 5px;
  /* 设置子节点列表的左内边距 */
  padding-bottom: 5px;
  font-size: 30px;
  // margin-left: 20px;
  dd {
    padding-right: 10px;
  }
}
.library_content_table .el-tree-node__children dd {
  padding-right: 10px;
}

.preview-dialog.el-dialog {
  display: flex;
  flex-direction: column;
}

.preview-dialog .el-dialog__body {
  padding: 0;
  flex: 1;
  overflow: hidden;
}

.preview-dialog .el-dialog__header {
  padding-bottom: 0px;
  background: #323639;
  color: #fff;
  height: 16px;
  box-sizing: border-box;
}
.preview-dialog .el-dialog__close {
  color: #fff;
}
.preview-dialog .el-dialog__headerbtn {
  top: 5px;
}
</style>

<style lang="scss" scoped>
.fact-pannel {
  width: 240px;
  padding: 10px;
  border: 1px solid #e5e5e5;
  margin-top: 64px;
}

.img_sign {
  height: 16px;
  width: 16px;
}

.content_header {
  margin-left: 10px;
  line-height: 30px;
  margin-top: 30px;
}

.content_category {
  margin-left: 20px;
  // height: 40px;
  //margin-top: 20px;
  .tag {
    margin-left: 20px;
  }
}

.el-row-tag {
  font-size: 16px;
  color: #808080;
  cursor: pointer;
  margin-left: 10px;
}

.el-row-span {
  margin-top: 5px;
  width: 200px;
  background-color: #f6f6f8;
  white-space: nowrap; /* 禁止文本换行 */
  overflow: hidden; /* 隐藏超出范围的内容 */
  text-overflow: ellipsis; /* 使用省略号 */
}

.content_tag {
  margin-top: 10px;
  // .tag {
  //   margin-left: 20px;
  // }
}

.library_content_table {
  margin-left: 18px;
  margin-top: 10px;
  font-size: 16px;
  background-color: #f6f6f8;
  margin-bottom: auto;
  margin-right: auto;
  border: 0px;
}

.table-set {
  width: 100%;
  margin-top: 30px;
  // border-collapse: collapse;
  // border: 0px solid #e5e5e5;
}

/* 调整树形控件节点和其子节点列表之间的距离 */
.el-tree .el-tree-node__children {
  padding-top: 45px;
  /* 设置子节点列表的左内边距 */
  padding-bottom: 45px;
  font-size: 30px;
}

.docum_search {
  width: 30%;
}

.content_end {
  margin-left: 20px;
  width: 90%;
  text-align: center;
}

.fixed-width {
  // width: 100px;
  /* 设置固定宽度为200像素 */
  display: inline-block;
  /* 或者使用 block，根据需求选择 */
  white-space: nowrap;
  /* 防止文本换行 */
  overflow: hidden;
  /* 超出部分隐藏 */
  text-overflow: ellipsis;
  /* 超出部分显示省略号，可选 */
  text-align: right;
  // margin-right: 20px;
  line-height: 2.5;
  font-size: 14px;
}

.fixed-label {
  width: 100%;
  /* 设置固定宽度为200像素 */
  display: inline-block;
  /* 或者使用 block，根据需求选择 */
  white-space: nowrap;
  /* 防止文本换行 */
  overflow: hidden;
  /* 超出部分隐藏 */
  text-overflow: ellipsis;
  /* 超出部分显示省略号，可选 */
  text-align: left;
  line-height: 2.5;
  font-size: 14px;
  a {
    font-weight: normal;
  }
}

.list-pagination {
  display: flex;
  justify-content: flex-end;
  margin: 1px 10 0px 0;
  background: #ffffff;
}

.actives {
  font-size: 14px;
  background: #00b5b1;
  border: 1px solid #00b5b1;
  color: #fff;
  border-radius: 10px;
  /* 圆角半径 */
  padding: 5px;
  /* 内边距 */
  margin: 5px;
  /* 外边距 */
}

.no-active {
  min-width: 100px;
  cursor: pointer;
  border-radius: 10px;
  border: 1px solid transparent;
  height: 38px;
  border: none;
  text-align: center;
  /* 圆角半径 */
  padding: 5px;
  /* 内边距 */
  margin: 5px;
  /* 外边距 */
  margin-left: 20px;
}

.active {
  font-size: 14px;
  background: #00b5b1;
  border: 1px solid #00b5b1;
  color: #fff;
  border-radius: 10px;
}

.div1,
.div2 {
  margin: 3px;
}

.div1 {
  margin-bottom: 1px;
  margin-left: 10px;
}

.div2 {
  border: 0px solid #e5e5e5;
}

.div2-tag {
  margin-bottom: 10px;
  padding: 10px;
}

.div2-row-tag {
  font-size: 16px;
  line-height: 1.5;
  color: #808080;
  width: 100%;
  cursor: pointer;
  line-height: 36px;
}

.div3,
.div4 {
  margin: 3px;
}

.div3 {
  margin-bottom: 1px;
  margin-left: 10px;
  margin-top: 10px;
}

.div4 {
  border: 0px solid #e5e5e5;
  font-size: 5px;
}

.overlay-tip {
  position: absolute;
  bottom: -12px;
  right: 9px;
  font-size: 12px;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/components/sigen/library/index.vue